import { render, staticRenderFns } from "./GovernateForm.vue?vue&type=template&id=dc403140&"
import script from "./GovernateForm.vue?vue&type=script&lang=js&"
export * from "./GovernateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports